module.exports = {
      id: "prayer-header-usage",
      viewBox: "0 0 300 193",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#prayer-header",
      toString: function () {
        return this.url;
      }
    }